export default __webpack_public_path__ + "static/media/asset.c9d4603b.svg";